export const Routes = {
  GET_SESSION_ID: 'https://api-store-dev.appcharge.com/store/orders/checkout-session/v2',
  CHECKOUT: '/checkout/v3',
  BOOT: '/v1/boot',
  PAYMENT: '/checkout/v3/finalize-payment',
  CANCEL_ORDER: '/checkout/v3/cancel',
  ADDRESS: '/checkout/v3/address-auto-complete',
  CALCULATE_TAX: '/checkout/v3/calculate-estimated-tax',
  APPLY_COUPON: '/checkout/v3/apply-promo-code',
  CANCEL_COUPON: '/checkout/v3/cancel-promo-code',
  ORDER: '/checkout/v3/orders',
  PAYMENT_STATUS: '/checkout/v3/payment/status',
  CREATE_SESSION: '/checkout/v3/payments/session',
  REMOVE_CARD: '/checkout/v3/remove-saved-card',
};

export const PciRoutes = {
  FINALIZE_PAYMENT: '/payment-pci-gw/checkout/finalize-payment',
};
